<template>
  <div class="personal-vacations">
    <div v-if="view === 'upcoming'">
      <div class="personal-no-vacation" v-if="filteredVacations.length === 0">
        {{ $t("אין לך חופשות קרובות.") }}
      </div>
      <div
        v-else
        v-for="(vacation, i) in filteredVacations"
        :key="i"
        class="personal-vacation vacation-upcoming"
      >
        <div class="vacation-section vacation-head">
          <h3>
            {{ vacation.site.name }}
            <!-- <span>#{{ vacation.number }}</span> -->
          </h3>
          <h3>
            PNR(מס הזמנה) - <span>{{ vacation.number }}</span>
          </h3>
          <h3>
            {{ profile.english_name }} - (<a target="_blank" :href="whatsapp">{{
              $t("שינוי שם")
            }}</a
            >)
          </h3>
          <ul class="flight-details">
            <li>
              <div>{{ $t("תחילת החופשה") }}</div>
              <div>
                {{ vacation.flights.leave.depart.date_pretty || $t("לא זמין") }}
              </div>
            </li>

            <i class="icon icon-airplane"></i>

            <li>
              <div>{{ $t("סיום החופשה") }}</div>
              <div>
                {{
                  vacation.flights.return.depart.date_pretty || $t("לא זמין")
                }}
              </div>
            </li>
          </ul>
        </div>

        <div class="vacation-section vacation-card">
          <div class="vacation-title">
            <i class="icon icon-airplane-blue d-tablet d-desktop"></i>
            <i class="icon icon-airplane-black d-phone"></i>
            {{ $t("פרטי טיסה") }}
          </div>
          <ul class="vacation-flights">
            <VacationFlight :flight="vacation.flights.leave" type="leave" />
            <VacationFlight :flight="vacation.flights.return" type="return" />
          </ul>
        </div>

        <div class="vacation-section vacation-card">
          <div class="vacation-title">
            <i class="icon icon-hotel d-tablet d-desktop"></i>
            <i class="icon icon-hotel-black d-phone"></i>
            {{ $t("פרטי מלון") }}
          </div>
          <div class="vacation-body vacation-body-hotel">
            <VacationHotel :hotel="vacation.hotel" />
          </div>
        </div>

        <div class="vacation-section vacation-card">
          <div class="vacation-title">
            <i class="icon icon-services d-tablet d-desktop"></i>
            <i class="icon icon-services-black d-mobile"></i>
            {{ $t("שירותי סקי כלולים") }}
          </div>
          <VacationServices
            :services="vacation.services"
            :actions="true"
            :vacation="vacation"
          />
        </div>
      </div>
    </div>
    <div v-else-if="view === 'past'">
      <div class="personal-no-vacation" v-if="filteredVacations.length === 0">
        {{ $t("עדיין לא יצאת לחופשה איתנו.") }}
      </div>
      <PastVacation
        v-else
        v-for="(vacation, i) in filteredVacations"
        :key="i"
        :vacation="vacation"
        :active="isVacationActive(i)"
        @change="onVacationChange(i, $event)"
      />
    </div>
  </div>
</template>

<script>
import VacationFlight from "./VacationFlight.vue";
import VacationHotel from "./VacationHotel.vue";
import VacationServices from "./VacationServices.vue";
import PastVacation from "./PastVacation.vue";

export default {
  components: {
    VacationFlight,
    VacationHotel,
    VacationServices,
    PastVacation,
  },

  props: {
    view: {
      type: String,
      default: "upcoming",
    },
    vacations: {
      type: Array,
      default: () => [],
    },
    profile: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      activeVacationIndex: -1,
      whatsapp: window.siteData.whatsapp_link,
    };
  },

  computed: {
    filteredVacations() {
      console.log(this.vacations);

      return this.vacations
        .filter((v) => v && v.category === this.view)
        .sort((vac, vac2) => {
          return (
            new Date(vac.flights.leave.depart.date) -
            new Date(vac2.flights.leave.depart.date)
          );
        });
    },
  },

  methods: {
    onVacationChange(i, active) {
      this.activeVacationIndex = active ? i : -1;
    },

    isVacationActive(i) {
      return this.activeVacationIndex === i;
    },
  },
};
</script>
